class HeadersModel {}
var HTTPMethod;
(function (HTTPMethod) {
  HTTPMethod[HTTPMethod["get"] = 0] = "get";
  HTTPMethod[HTTPMethod["post"] = 1] = "post";
  HTTPMethod[HTTPMethod["delete"] = 2] = "delete";
  HTTPMethod[HTTPMethod["put"] = 3] = "put";
  HTTPMethod[HTTPMethod["patch"] = 4] = "patch";
})(HTTPMethod || (HTTPMethod = {}));
function aggregatorUrl(api) {
  return endpoint => apiUrlSettings => function () {
    const searchParams = new URLSearchParams();
    if (arguments.length) {
      searchParams.set("id", api.endpoints[endpoint].getRemoteURL(...arguments));
      if (apiUrlSettings) {
        searchParams.set("variables", JSON.stringify({
          realm: apiUrlSettings.realm,
          territory: apiUrlSettings.territory,
          language: apiUrlSettings.language,
          itemNumber: arguments.length <= 2 ? undefined : arguments[2]
        }));
      }
    }
    const queryString = searchParams.toString();
    const configUrl = queryString ? "?".concat(queryString) : "";
    return "".concat(api.baseURL).concat(decodeURIComponent(configUrl));
  };
}
function apiURL(api, realmOnly) {
  return endpoint => apiUrlSettings => function () {
    let configUrl = "";
    if (apiUrlSettings) {
      if (realmOnly) {
        configUrl = "/".concat(apiUrlSettings.realm);
      } else {
        configUrl = "/".concat(apiUrlSettings.realm, "/").concat(apiUrlSettings.territory, "/").concat(apiUrlSettings.language);
      }
    }
    return "".concat(api.baseURL).concat(configUrl, "/").concat(api.version).concat(api.endpoints[endpoint].getRemoteURL(...arguments));
  };
}
function apiMethod(api) {
  return endpoint => HTTPMethod[api.endpoints[endpoint].method];
}
function localEndpoint(api) {
  return endpoint => function () {
    return api.endpoints[endpoint].getLocalURL(...arguments);
  };
}
function routeDefinition(api) {
  return endpoint => api.endpoints[endpoint].routeDefinition;
}
function buildExport(api, endpoint, realmOnly) {
  return {
    url: apiURL(api, realmOnly)(endpoint),
    aggregatorUrl: aggregatorUrl(api)(endpoint),
    method: apiMethod(api)(endpoint),
    localEndpoint: api.endpoints[endpoint].getLocalURL ? localEndpoint(api)(endpoint) : null,
    routeDefinition: api.endpoints[endpoint].getLocalURL ? routeDefinition(api)(endpoint) : null
  };
}
export { HTTPMethod, HeadersModel, aggregatorUrl, apiMethod, apiURL, buildExport, localEndpoint, routeDefinition };